<template>
  <div>
    <slot></slot>
    <pre v-highlightjs="source">
          <code class="html"/>
    </pre>
    <BaseTable
      :data="getData(table.type)"
      v-for="table in tables"
      :key="table.type"
      :columns="table.columns"
      :type="table.type"
    />
  </div>
</template>

<script>
import "highlight.js/styles/github.css";
import highlightjs from "./highlightjs";
import BaseTable from "./Tables/BaseTable.vue";
import Tables from "./Tables/tableType";
export default {
  name: "DemoPage",
  directives: {
    highlightjs
  },
  components: {
    BaseTable
  },
  props: {
    source: String,
    props: Array,
    events: Array,
    methods: Array,
    slots: Array
  },
  data() {
    return {
      tables: Tables
    };
  },
  methods: {
    getData(type) {
      return this[type];
    }
  }
};
</script>

<style scoped></style>
